module.exports = __webpack_public_path__ + "static/img/03.c7a756b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daolan/03.jpg
// module id = LXZb
// module chunks = 1